const IndexBy = (data, index) => {
  const indexed = {}
  data.forEach(dataItem => indexed[dataItem[index]] = dataItem)
  return indexed
}

export default IndexBy
